import inputsConfig from "./inputConfig";

export default {
  accordion: false,
  items: [
    {
      name: "Solver's email",
      required: true,
      fields: inputsConfig.email,
    },
    {
      name: "Select an action for this solver",
      required: true,
      fields: inputsConfig.action_type,
    },
  ],
};

export const optionalItems = {
  force_challenger: [
    {
      name: "Applicable challenge",
      required: true,
      fields: inputsConfig.company_team_id,
    },
    {
      name: "Challenger role",
      required: true,
      fields: inputsConfig.challenger_role,
    },
    {
      name: "Invitation email",
      description:
        "Would you like to send an email invitation to a future challenger?",
      required: true,
      fields: inputsConfig.send_email,
    },
  ],
  correct_email: [
    {
      name: "New email address",
      required: true,
      fields: inputsConfig.correct_email,
    },
  ],
  redact_solver_account: [
    {
      name: "TrustArc ID",
      required: true,
      fields: inputsConfig.trust_arc_id,
    },
  ],
};
